import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import NotFound from "../../blogs/utils/NotFound";

export const slugToFileName = (slug) => {
    return slug
        .split("-")
        .map((word) => {
            if (/^[0-9]+$/.test(word)) return word;
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join("") + ".js";
};

const SolutionWrapper = () => {
    const { solutionId } = useParams();

    const SolutionComponent = useMemo(() => {
        const context = require.context("../../solutions/", false, /\.js$/);
        const fileName = slugToFileName(solutionId);

        try {
            const path = context.keys().find((p) =>
                p === `./${fileName}` ||
                p.toLowerCase() === `./${fileName.toLowerCase()}`
            );
            if (!path) return null;
            return context(path).default;
        } catch (err) {
            console.error("Solution loading error:", err);
            return null;
        }
    }, [solutionId]);

    if (!SolutionComponent) return <NotFound />;
    return <SolutionComponent />;
};

export default SolutionWrapper;
